'use client';

import { c as _c } from "react/compiler-runtime";
import { readApiErrorMessage } from '@lib/api/utils/read-api-error-message';
import { useAuthedQuery } from '@lib/query/use-authed-query';
import type { TeamTemplate } from '@lib/team-templates/services/list-team-templates';
import type { Team } from '@lib/team/types/team';
export const teamTemplatesQueryKey = ['templates', 'team', 'list'] as const;
export interface TeamTemplatesData {
  templates: TeamTemplate[];
  /** Teams available to the caller, so rows can be labelled without a second fetch. */
  teams: Team[];
}
interface TeamTemplatesResponse {
  success: boolean;
  data: TeamTemplatesData;
}

/**
 * Templates shared with teams available to the caller.
 *
 * A flat list, not a tree: a team-shared template's node stays under its
 * author's personal root, which teammates cannot read, so `team_id` is
 * the only link between them.
 */
export function useTeamTemplatesQuery(t0) {
  const $ = _c(4);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  if ($[2] !== enabled) {
    t3 = {
      queryKey: teamTemplatesQueryKey,
      enabled,
      queryFn: _temp
    };
    $[2] = enabled;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return useAuthedQuery(t3);
}
async function _temp() {
  const response = await fetch("/api/protected/team-templates");
  if (!response.ok) {
    throw new Error(await readApiErrorMessage(response));
  }
  const body = (await response.json()) as TeamTemplatesResponse;
  return body.data;
}